/** Remove this origin's former SDK identifiers, even if its key was removed. */
export const clearAnalyticsStorage = (apiKey?: string) => {
	const tokens = new Set<string>();
	if (apiKey)
		tokens.add(
			apiKey.replace(/\+/g, "PL").replace(/\//g, "SL").replace(/=/g, "EQ"),
		);
	const rememberToken = (key: string) => {
		const match = /^ph_(.+)_posthog$/.exec(key);
		if (match) tokens.add(match[1]);
	};
	for (const cookie of document.cookie.split(";"))
		rememberToken(cookie.trim().split("=")[0]);
	for (const storageName of ["localStorage", "sessionStorage"] as const) {
		try {
			for (const key of Object.keys(window[storageName])) {
				rememberToken(key);
				const marker = /^__ph_opt_in_out_(.+)$/.exec(key);
				if (marker) tokens.add(marker[1]);
			}
		} catch {
			// Storage may be unavailable in privacy-restricted browsers.
		}
	}
	for (const token of tokens) {
		for (const storageName of ["localStorage", "sessionStorage"] as const) {
			try {
				const storage = window[storageName];
				for (const key of Object.keys(storage)) {
					if (
						key.startsWith(`ph_${token}_`) ||
						key === `__ph_opt_in_out_${token}` ||
						(apiKey && key === `__ph_opt_in_out_${apiKey}`)
					)
						storage.removeItem(key);
				}
			} catch {
				// Removal remains best-effort if the browser denies storage access.
			}
		}
		const expire = (domain = "") => {
			// biome-ignore lint/suspicious/noDocumentCookie: remove optional analytics cookies.
			document.cookie = `ph_${token}_posthog=; Max-Age=0; Path=/; SameSite=Lax${domain ? `; Domain=${domain}` : ""}`;
		};
		expire();
		// Older SDK defaults could set the cookie on a parent domain.
		const parts = window.location.hostname.split(".");
		while (parts.length >= 2) {
			expire(parts.join("."));
			parts.shift();
		}
	}
};
